// apps/client/src/components/BingoCard.tsx
//
// Bingo Card Component - Uses new UI Kit BingoCardUI
// Business logic preserved, visual layer delegated to UI Kit
//

import { BingoCardUI } from '../ui-kit/BingoCard';

interface BingoCardProps {
    grid: (number | null)[][];
    hits: number[];
    isPlaying?: boolean;
    ticketId?: string;
}

export function BingoCard({ grid, hits, isPlaying = false, ticketId }: BingoCardProps) {
    return (
        <BingoCardUI
            grid={grid}
            hits={hits}
            isPlaying={isPlaying}
            ticketId={ticketId ? `#${ticketId}` : undefined}
            showStats={true}
        />
    );
}
